import React, {Dispatch, SetStateAction, useEffect} from 'react'
import {LoadingState} from '../../../global'

type useScrollHandlerType = {
  ref: React.RefObject<HTMLDivElement>,
  onScrollEnd: () => void,
  setLoading: Dispatch<SetStateAction<LoadingState>>
}

export const useScrollHandler = ({ref, onScrollEnd, setLoading}: useScrollHandlerType) => {

  useEffect(() => {
    const currentRef = ref.current
    setLoading('idle')
    const handleScroll = () => {
      if (currentRef && currentRef.scrollTop + currentRef.clientHeight >= currentRef.scrollHeight - 1) {
        setLoading('pending')
        onScrollEnd()
      }
    }

    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [ref, onScrollEnd, setLoading])
}
